import {nameForAnalytics} from '@rdcomponents/navigation/navigation-type';

import {NavigationItemConfigType} from '../routing-type';

import {resolveChainForPathname, RouteMatchRowType} from './route-path-resolution';

const ANALYTICS_SECTION_SEPARATOR = ' - ';

function flattenNavigationConfigForMatching(
    items: Array<NavigationItemConfigType>,
    ancestors: Array<NavigationItemConfigType> = []
): Array<RouteMatchRowType<NavigationItemConfigType>> {
    return items.flatMap((item) => {
        const pattern = (item.path ?? item.key)?.toString() ?? '';
        const chain = [...ancestors, item];

        const ownRow: Array<RouteMatchRowType<NavigationItemConfigType>> = pattern.startsWith('/')
            ? [{pattern, chain}]
            : [];

        const childRows =
            item.children && item.children.length > 0 ? flattenNavigationConfigForMatching(item.children, chain) : [];

        return [...ownRow, ...childRows];
    });
}

/**
 * Breadcrumb for analytics from navigation config: parent > … > matched route, using [nameForAnalytics].
 * Path matching follows the same rules as menu selected keys (matchPath + pattern specificity).
 */
export function getAnalyticsSectionPathFromNavigationConfig(
    pathname: string,
    navigationConfig: Array<NavigationItemConfigType>
): string {
    const rows = flattenNavigationConfigForMatching(navigationConfig);
    const chain = resolveChainForPathname(pathname, rows);

    const labels = chain
        .map((item) => {
            return item[nameForAnalytics] || '';
        })
        .filter(Boolean);

    return labels.join(ANALYTICS_SECTION_SEPARATOR);
}
